import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe} from '@angular/common';
import { CoreModule } from 'src/app/core/core.module';
import { FormsModule } from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SpHmiConverterComponent } from './sp-hmi-converter.component';
import { SPHmiConverterRoutingModule } from './sp-hmi-converter-routing.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    NgbModule,
    SPHmiConverterRoutingModule
  ],
  declarations: [
    SpHmiConverterComponent
  ],
  providers:[DatePipe],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class SpHmiconverterModule { }
